class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartDrawerSidePanelBreakpoint = 1024;

    const cartDrawerSection = document.querySelector(
      '.shopify-section-cart-drawer'
    );

    const headerSection = document.querySelector(
      '.shopify-section-header'
    );

    this.cartDrawerID = cartDrawerSection
      ? cartDrawerSection.id.replace('shopify-section-', '')
      : null;

    this.headerID = headerSection
      ? headerSection.id.replace('shopify-section-', '')
      : null;

    this.CartDrawer = this.closest('.cart-drawer') || this;

    this.sidePanel = this.CartDrawer?.querySelector(
      '.drawer-recommendations--side-panel'
    );

    this.drawerRecommendations = this.CartDrawer?.querySelector(
      '.drawer-recommendations'
    );

    this.recommendationsBlockHasDifferentBg =
      this.dataset.recommendationsBlockHasDifferentBg === 'true';

    this.enableShadow =
      this.dataset.enableShadow === 'true';

    this.enableBorder =
      this.dataset.enableBorder === 'true';

    this.cartLinks =
      document.querySelectorAll('#cart-link');

    this.drawer =
      this.CartDrawer?.querySelector('.drawer');

    this.overlay =
      document.querySelector('body > .overlay') ||
      this.CartDrawer?.querySelector('.overlay') ||
      this.querySelector('#CartDrawer-Overlay') ||
      document.getElementById('CartDrawer-Overlay');

    /*
     * ESC close
     */
    document.addEventListener('keyup', (event) => {
      if (
        event.code &&
        event.code.toUpperCase() === 'ESCAPE' &&
        this.drawer?.closest('.open')
      ) {
        this.close();
      }
    });

    /*
     * Drawer-specific overlay
     */
    const overlayElement =
      this.querySelector('#CartDrawer-Overlay') ||
      document.getElementById('CartDrawer-Overlay');

    if (overlayElement) {
      overlayElement.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    /*
     * Global/theme overlay
     */
    if (
      this.overlay &&
      this.overlay !== overlayElement
    ) {
      this.overlay.addEventListener(
        'click',
        () => {
          this.close();
        }
      );
    }

    this.setHeaderCartIconAccessibility();

    /*
     * Shopify theme editor
     */
    document.addEventListener(
      'shopify:section:load',
      (event) => {
        if (
          event.target?.closest(
            '.shopify-section-cart-drawer'
          )
        ) {
          this.refreshElements();
          this.open();
        }
      }
    );

    document.addEventListener(
      'shopify:section:select',
      (event) => {
        if (
          event.target?.closest(
            '.shopify-section-cart-drawer'
          )
        ) {
          if (
            typeof Shopify !== 'undefined' &&
            Shopify.designMode
          ) {
            document.body.classList.add(
              'disable-scroll-body'
            );
          }

          this.sectionSelect();
        }
      }
    );

    document.addEventListener(
      'shopify:section:deselect',
      (event) => {
        if (
          event.target?.closest(
            '.shopify-section-cart-drawer'
          )
        ) {
          this.close();
        }
      }
    );

    if (this.sidePanel) {
      this.adjustSidePanelForScreenSize();

      window.addEventListener(
        'resize',
        this.adjustSidePanelForScreenSize.bind(this)
      );
    }
  }


  /*
   * Re-find elements after Shopify replaces
   * cart drawer HTML.
   */
  refreshElements() {
    this.CartDrawer =
      this.closest('.cart-drawer') || this;

    this.drawer =
      this.CartDrawer?.querySelector('.drawer');

    this.drawerRecommendations =
      this.CartDrawer?.querySelector(
        '.drawer-recommendations'
      );

    this.sidePanel =
      this.CartDrawer?.querySelector(
        '.drawer-recommendations--side-panel'
      );

    this.overlay =
      document.querySelector('body > .overlay') ||
      this.CartDrawer?.querySelector('.overlay') ||
      this.querySelector('#CartDrawer-Overlay') ||
      document.getElementById('CartDrawer-Overlay');
  }


  adjustSidePanelForScreenSize() {
    if (!this.drawerRecommendations) {
      return;
    }

    const drawerRecommendationsHeader =
      this.drawerRecommendations.querySelector(
        '.js-cart-drawer-header'
      );

    const drawerRecommendationsTabsResult =
      this.drawerRecommendations.querySelector(
        '.tabs-block__results'
      );

    const isSmallScreen =
      window.matchMedia(
        `(max-width: ${this.cartDrawerSidePanelBreakpoint}px)`
      ).matches;

    const toggleClass = (
      element,
      className,
      toAdd
    ) => {
      if (element) {
        element.classList.toggle(
          className,
          toAdd
        );
      }
    };

    toggleClass(
      this.drawerRecommendations,
      'drawer-recommendations--side-panel',
      !isSmallScreen
    );

    toggleClass(
      this.drawerRecommendations,
      'scroll-area',
      !isSmallScreen
    );

    toggleClass(
      this.drawerRecommendations,
      'hide-scrollbar',
      !isSmallScreen
    );

    toggleClass(
      this.drawerRecommendations,
      'full-width-block',
      isSmallScreen &&
        this.recommendationsBlockHasDifferentBg
    );

    toggleClass(
      this.drawerRecommendations,
      'modal--shadow',
      !isSmallScreen &&
        this.enableShadow
    );

    toggleClass(
      this.drawerRecommendations,
      'modal--border',
      !isSmallScreen &&
        this.enableBorder
    );

    toggleClass(
      drawerRecommendationsHeader,
      'cart-drawer__header',
      !isSmallScreen
    );

    toggleClass(
      drawerRecommendationsTabsResult,
      'tabs-block__results--allow-height-change',
      !isSmallScreen
    );
  }


  setHeaderCartIconAccessibility() {
    this.cartLinks =
      document.querySelectorAll('#cart-link');

    Array.from(this.cartLinks).forEach(
      (cartLink) => {
        /*
         * Prevent duplicate listeners.
         */
        if (
          cartLink.dataset.cartDrawerInitialized ===
          'true'
        ) {
          return;
        }

        cartLink.dataset.cartDrawerInitialized =
          'true';

        cartLink.setAttribute(
          'role',
          'button'
        );

        cartLink.setAttribute(
          'aria-haspopup',
          'dialog'
        );

        cartLink.addEventListener(
          'click',
          (event) => {
            event.preventDefault();

            this.open(cartLink);
          }
        );

        cartLink.addEventListener(
          'keydown',
          (event) => {
            if (
              event.code &&
              event.code.toUpperCase() === 'ENTER'
            ) {
              event.preventDefault();

              this.open(cartLink);
            }
          }
        );
      }
    );
  }


  sectionSelect() {
    this.cartLink =
      document.querySelector('#cart-link');

    this.open(this.cartLink);
  }


  open(triggeredBy) {
    /*
     * Important:
     * cart HTML may have just been replaced.
     */
    this.refreshElements();

    if (triggeredBy) {
      this.setActiveElement(triggeredBy);
    }

    /*
     * Close Quick View safely.
     */
    if (
      document.body.classList.contains(
        'quick-view-open'
      )
    ) {
      document.body.classList.remove(
        'hidden',
        'quick-view-open',
        'quick-view-load'
      );

      const openedQuickView =
        document.querySelector(
          '.popup-wrapper__quick-view.open'
        );

      if (openedQuickView) {
        const details =
          openedQuickView.closest('details');

        const quickViewContent =
          openedQuickView.closest(
            '.quick-view__content'
          );

        details?.removeAttribute('open');

        quickViewContent?.classList.remove(
          'hide-cover'
        );

        const quickViewOverlay =
          quickViewContent?.querySelector(
            '.overlay'
          );

        quickViewOverlay?.classList.remove(
          'open'
        );

        openedQuickView.classList.remove(
          'open'
        );

        if (quickViewContent) {
          quickViewContent.innerHTML = '';
        }
      }
    }

    setTimeout(() => {
      /*
       * Re-check because DOM can change between
       * renderContents() and this timeout.
       */
      this.refreshElements();

      this.classList.add(
        'animate',
        'open'
      );

      this.drawer?.classList.add('open');

      this.overlay?.classList.add('open');

      document.body.classList.add('hidden');

      this.CartDrawer?.setAttribute(
        'tabindex',
        '-1'
      );

      requestAnimationFrame(() => {
        setTimeout(() => {
          const closeButton =
            this.CartDrawer?.querySelector(
              '.button-close'
            );

          /*
           * This was one of the possible null crashes.
           */
          if (closeButton) {
            closeButton.focus();

            if (
              typeof trapFocus === 'function' &&
              this.CartDrawer
            ) {
              trapFocus(
                this.CartDrawer,
                closeButton
              );
            }
          }
        }, 10);
      });
    }, 10);
  }


  close() {
    if (
      typeof Shopify !== 'undefined' &&
      Shopify.designMode
    ) {
      document.body.classList.remove(
        'disable-scroll-body'
      );
    }

    this.classList.remove('open');

    this.drawer?.classList.remove('open');

    this.overlay?.classList.remove('open');

    if (
      typeof removeTrapFocus === 'function'
    ) {
      removeTrapFocus(
        this.activeElement
      );
    }

    document.body.classList.remove(
      'hidden'
    );

    document.dispatchEvent(
      new CustomEvent('body:visible')
    );
  }


  renderContents(parsedState) {
    if (
      !parsedState ||
      !parsedState.sections
    ) {
      console.warn(
        'CartDrawer: Missing sections in cart response.',
        parsedState
      );

      /*
       * Product may still have been successfully
       * added even if bundled sections are missing.
       */
      this.open();

      return;
    }

    if (
      this.classList.contains(
        'is-empty'
      )
    ) {
      this.classList.remove(
        'is-empty'
      );
    }

    this.productId =
      parsedState.id;

    this.getSectionsToRender().forEach(
      (section) => {
        if (
          !section.id ||
          !section.selector
        ) {
          return;
        }

        const sectionElements =
          document.querySelectorAll(
            section.selector
          );

        const sectionHtml =
          parsedState.sections[
            section.id
          ];

        if (!sectionHtml) {
          console.warn(
            `CartDrawer: Section "${section.id}" missing from response.`
          );

          return;
        }

        if (
          !sectionElements ||
          sectionElements.length === 0
        ) {
          console.warn(
            `CartDrawer: Element "${section.selector}" not found.`
          );

          return;
        }

        const newHtml =
          this.getSectionInnerHTML(
            sectionHtml,
            section.selector
          );

        /*
         * Do not replace the section with undefined
         * or crash when selector isn't present.
         */
        if (newHtml === null) {
          console.warn(
            `CartDrawer: Selector "${section.selector}" missing from returned section "${section.id}".`
          );

          return;
        }

        Array.from(
          sectionElements
        ).forEach(
          (sectionElement) => {
            sectionElement.innerHTML =
              newHtml;
          }
        );
      }
    );

    /*
     * Elements inside CartDrawer may have been
     * replaced by innerHTML above.
     */
    this.refreshElements();

    /*
     * Rebind cart icon after header HTML update.
     */
    this.setHeaderCartIconAccessibility();

    setTimeout(() => {
      this.refreshElements();

      const overlayElement =
        this.querySelector(
          '#CartDrawer-Overlay'
        ) ||
        document.getElementById(
          'CartDrawer-Overlay'
        );

      /*
       * Prevent duplicate overlay listeners.
       */
      if (
        overlayElement &&
        overlayElement.dataset
          .cartDrawerInitialized !== 'true'
      ) {
        overlayElement.dataset
          .cartDrawerInitialized = 'true';

        overlayElement.addEventListener(
          'click',
          this.close.bind(this)
        );
      }

      /*
       * Trigger existing cart update logic.
       */
      if (
        window.cartFunctionsInitialized
      ) {
        setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent(
              'cart:updated',
              {
                detail: parsedState
              }
            )
          );
        }, 200);
      }

      /*
       * Open drawer after successful update.
       */
      this.open();
    }, 100);
  }


  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) {
      return null;
    }

    try {
      const documentHTML =
        new DOMParser().parseFromString(
          html,
          'text/html'
        );

      const element =
        documentHTML.querySelector(
          selector
        );

      /*
       * Original code did:
       *
       * .querySelector(selector).innerHTML
       *
       * which crashes when querySelector()
       * returns null.
       */
      if (!element) {
        return null;
      }

      return element.innerHTML;
    } catch (error) {
      console.error(
        'CartDrawer: Unable to parse section HTML.',
        error
      );

      return null;
    }
  }


  getSectionsToRender() {
    const arraySections = [];

    if (this.cartDrawerID) {
      arraySections.push({
        id: this.cartDrawerID,
        selector: '#CartDrawer'
      });
    }

    if (this.headerID) {
      arraySections.push({
        id: this.headerID,
        selector:
          `#cart-icon-bubble-${this.headerID}`
      });
    }

    return arraySections;
  }


  getSectionDOM(
    html,
    selector = '.shopify-section'
  ) {
    if (!html) {
      return null;
    }

    try {
      return new DOMParser()
        .parseFromString(
          html,
          'text/html'
        )
        .querySelector(selector);
    } catch (error) {
      console.error(
        'CartDrawer: Unable to get section DOM.',
        error
      );

      return null;
    }
  }


  setActiveElement(element) {
    if (!element) return;

    this.activeElement = element;

    if (
      element.closest?.('.cart-icon')
    ) {
      const cart =
        element.querySelector?.(
          'a.cart'
        );

      if (cart) {
        this.activeElement = cart;
      }
    }

    if (
      element.closest?.(
        '.popup-wrapper__quick-view'
      )
    ) {
      const cardProduct =
        element.closest(
          '.card-product'
        );

      const quickViewButton =
        cardProduct?.querySelector(
          '.card-quick-view'
        );

      if (quickViewButton) {
        this.activeElement =
          quickViewButton;
      }
    }
  }
}


if (
  !customElements.get('cart-drawer')
) {
  customElements.define(
    'cart-drawer',
    CartDrawer
  );
}